<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-8">
                    <card>
                        
                        <form>
                            <!-- <div class="row"> -->
                                <!-- <div class="col-md-12"> -->
                                    <!-- Botanical name -->
                                    <div class="row">
                                        <div class="col-md-11">
                                            <h4 slot="header" class="card-title">Suggestion</h4>
                                        </div>
                                        
                                    </div>

                                 

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="title" class="property-label">Botanical name</label>
                                                <input
                                                        id="title"
                                                        v-model="data.botanical_name"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="subtitle" class="property-label">Common name</label>
                                                <input
                                                        id="subtitle"
                                                        v-model="data.common_name"
                                                        class="form-control"
                                                        aria-describedby="addon-right addon-left">
                                            </div>
                                        </div>
                                    </div>


                                     <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="subtitle" class="property-label">Photos</label>
                                                
                                                <div v-if="data.photos.length > 0" class="row images-row">
                                                    <div 
                                                        v-for="(image, image_index) in data.photos" 
                                                        @click.prevent="downloadImage(data.photos[image_index])" 
                                                        v-bind:key="image_index"
                                                        class="col-md-2 img-item">
                                                            <img alt="Remove" class="images-col" v-bind:src="data.photos[image_index]"/>
                                                    </div>
                                                
                                                </div>

                                                <div v-if="data.photos.length == 0" class="row images-row">
                                                    No photos
                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                        </form>
                    </card>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Card from 'src/components/UIComponents/Cards/Card.vue';

    export default {
        components: {
            Card,
        },
        data() {
            return {
                data: {
                    
                },
                token: localStorage.getItem('token'),
            }
        },
        created: function () {
            this.id = this.$route.params.id;

            if (this.id) {
                this.getInfo(this.id);
            }
        },
        methods: {
            getInfo: async function () {
                let self = this;
                let token = localStorage.getItem('token');

                const {data} = await axios.get(
                    `${this.$hostname}/admin/suggestions/${self.id}`,
                    {
                        'headers': {
                            'Authorization':  token
                        }
                    });

                
                self.data = data;
                
                if (this.id) {
                    document.title = `${data.botanical_name}`;
                }
            },
            downloadImage: function (link) {
                window.open(link, '_blank');
            },
        }
    }

</script>
<style scoped>
    .property-label {
        font-size: 15px;
        color: black;
        font-weight: bold;
    }
    button:disabled,
    button[disabled] {
        cursor: not-allowed;
    }

    .btn-save {
        width: 150px;
    }

    .col-md-4 {
        padding: 15px !important;
    }

    .checkbox-block {
        margin-top: 40px;
        margin-left: 40px;
    }

    .btn-file {
        display: none;
    }

    .image-block {
        max-width: 100%;
    }

    .form-check-inline {
        display: inline-block;
    }

    .label-checkbox {
        margin-right: 10px
    }

    .link {
        cursor: pointer;
        text-decoration: underline;
    }
    .card-body p {
        font-weight: 300;
        font-style: italic;
    }

    .card-body form {
        /*margin-top: 15px;*/
    }

    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        padding-left: 30px;
        margin-bottom: 12px;
        cursor: pointer;
        font-size: 12px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #ccc;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        opacity: 0.8;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #54abfe;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid #fff;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .preview-device {
        display: inline-block;
        width: 32%;
        margin-left: 10px;
    }
    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }
    .device-block.inactive {
        opacity: 0.5;
    }
    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    .device1 {
        display: inline-block;
        /*width: 281px;*/
        /*height: 609px;*/
        width: 337px;
        height: 731px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 40px;
    }
    .device2 {
        display: inline-block;
        /*width: 310px;*/
        /*height: 552px;*/
        width: 372px;
        height: 662px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 50px;
    }
    .device3 {
        display: inline-block;
        /*width: 384px;*/
        /*height: 512px;*/
        width: 461px;
        height: 614px;
        border: 3px solid #000;
        border-radius: 10px;
        margin-left: 50px;
    }
    .mt30 {
        margin-top: 30px;
    }
    .p-photo {
        max-width: 100%;
        margin-bottom: 20px;
    }
    .section-row {
        border: 1px solid #E3E3E3;
        margin: 1px;
        padding: 20px;
        display: block;
    }
    .s-row {
        align-items: self-end;
    }
    .images-col {
        max-width: 100%;
        margin-bottom: 20px;
    }
    .images-row {
       border: 1px solid #E3E3E3;
        margin: 1px;
        padding: 20px;
        /* display: block;  */
    }
    .img-item {
        /* элемент тени */
        cursor: pointer;
        -webkit-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1);
        box-shadow: 0 5px 2px -3px rgba(0, 0, 0, 0.1), 0 1px 0px rgba(0, 0, 0, 0.1); 
    }
    .img-item:hover { 
        /* элемент тени если наведен курсор */ 
        -webkit-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3); 
        -moz-box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.5), 0 1px 0px rgba(0, 0, 0, 0.3); 
        box-shadow: 0 15px 10px -10px rgba(0, 0, 0, 0.3), 0 1px 0px rgba(0, 0, 0, 0.1); 
        /* элемент тени если наведен курсор конец */ 
 }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Suggestions/SuggestionInfo.vue